import { render, staticRenderFns } from "./RevenueWithCostsList.vue?vue&type=template&id=2960fd39&scoped=true&"
import script from "./RevenueWithCostsList.vue?vue&type=script&lang=js&"
export * from "./RevenueWithCostsList.vue?vue&type=script&lang=js&"
import style0 from "./RevenueWithCostsList.vue?vue&type=style&index=0&id=2960fd39&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2960fd39",
  null
  
)

export default component.exports